export class StorageConstants {
  public static selectedlanguage = 'c3825b05-0807-41ae-8872-87cbb11f0cd3';
  public static capass = '39f7d0a0-033e-4566-a52d-312af3916433';
  public static pass = '7c3c51d0-978f-11ed-a8fc-0242ac120002';
}
